import FilterSelectView from './FilterSelectView';

export default FilterSelectView;
